export default __webpack_public_path__ + "static/media/icon-medical-leave-full.c1d61e8a.svg";